import React, { useEffect, useState, useCallback, useMemo } from "react";
import {  toast } from 'react-toastify'; 
import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  ModalBody,
  Modal,
  ModalHeader,
} from "reactstrap";
import TableContainer from "../../Components/Common/TableContainer";  
import BreadCrumb from "../../Components/Common/BreadCrumb";
//Import actions 
import { getInventoryList, baseURL } from '../../utils/inventory'; 



const InventoryList = () => {    
  const [inventory, setInventory] = useState(null); 
  
  const [modal, setModal] = useState(false); 
  const [inventoryList, setInventoryList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
 
  // Clear search function
  const clearSearch = useCallback(() => {
    setSearchTerm('');
    // Trigger a search with empty string to clear the TableContainer's internal search
    // This will clear the search input and reload data without search filter
    handlePageChange({
      pageIndex: currentPage,
      pageSize: pageSize,
      globalFilter: '',
      searchTerm: '',
      search: '',
      query: ''
    });
  }, [currentPage, pageSize]);
 
  useEffect(() => { 
    loadInventoryList(currentPage, pageSize); 
  }, [currentPage, pageSize]);

  // Initial load
  useEffect(() => {
    loadInventoryList(1, 10);
  }, []); 

  const toggle_modal = useCallback(() => {
      if (modal) {
        setModal(false);
        loadInventoryList(currentPage, pageSize);
      } else {
        setModal(true);
      }
    }, [modal, currentPage, pageSize]);      
  
  const loadInventoryList = async (page = currentPage, size = pageSize, searchTerm = null) => {
    try { 
      setLoading(true);
       
      const requestData = {
        page: page,
        per_page: size
      };
      
      // Add search term if provided
      if (searchTerm && searchTerm.trim()) {
        requestData.ilike = searchTerm.trim();
      }
      
      const response = await getInventoryList(requestData);   
      if(response.status === 200){ 
        console.log('getInventoryList response', response.data); 
        setTotal(response.data.total);
        setInventoryList(response.data.data);  
        setCurrentPage(page);
        setPageSize(size);
        console.log('total', total, 'page', page, 'pagesize', pageSize);
      }
    } catch (error) {
       
      toast.error(error.message); 
    } finally {
      setLoading(false);
    }
  };

  // Add pagination handler
  const handlePageChange = async (params) => {
     
    try {
      setLoading(true);
      // Add null check and proper parameter names
      const page = params?.pageIndex || 1;
      const pageSize = params?.pageSize || 10;
      
      console.log('=== Inventory handlePageChange Debug ===');
      console.log('Full params object:', params);
      console.log('params keys:', Object.keys(params || {}));
      console.log('params values:', Object.values(params || {}));
      console.log('params.searchTerm:', params?.searchTerm);
      console.log('params.search:', params?.search);
      console.log('params.query:', params?.query);
      console.log('params.filter:', params?.filter);
      console.log('params.globalFilter:', params?.globalFilter);
      
      const searchTerm = params?.searchTerm || params?.search || params?.query || params?.globalFilter || '';
      
      console.log('Extracted search term:', searchTerm);
      
      // Update the search term state
      setSearchTerm(searchTerm);
      
      const requestData = {
        page: page,
        per_page: pageSize
      };
      
      // Add search term if provided
      if (searchTerm && searchTerm.trim()) {
        requestData.ilike = searchTerm.trim();
        console.log('Added ilike parameter:', requestData.ilike);
      } else {
        console.log('No search term found, ilike not added');
      }
      
      console.log('Final request data:', requestData);
      console.log('=== End Inventory Debug ===');
      
      const response = await getInventoryList(requestData);
      // console.log('getInventoryList handlePageChange', response.data.data); 

      if(response.status === 200) {
        setTotal(response.data.total);
        setInventoryList(response.data.data);   
        setCurrentPage(page);
        setPageSize(pageSize);
      }
    } catch (error) {
       
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
    
  const handleInfo = useCallback((arg) => {
    const inventory = arg;  
    setInventory(inventory);
    toggle_modal();
  });    
 
  

  // Column
  const columns = useMemo(
    () => [
      {
        id: 'id',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
      },
      // {
      //   header: "",
      //   id: "product_image",
      //   accessorFn: row => row.product_edition?.images[0].image_url, // assuming image name is in row.product.image
      //   cell: ({ getValue }) => {
      //     const imageName = getValue();
      //     if (!imageName) return null;
      //     return (
      //       <img
      //         src={`/api/file/product/image/${imageName}`}
      //         alt="Product"
      //         style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 4, marginRight: 8 }}
      //       />
      //     );
      //   },
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   size: 40,
      // },
      {
        header: "Product Name",
        accessorKey: "product.name",
        enableColumnFilter: false,
        cell: ({ getValue, row }) => {
          // Render product name with image thumbnail to the left
          // console.log('row', row.original.product_edition.images);
          const imageName = row.original.product_edition.images?.[0]?.image_url;
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {imageName && (
                <img
                  src={`${baseURL}/file/product/image/${imageName}`}
                  alt="Product"
                  style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 4, marginRight: 8 }}
                />
              )}
              <span>{getValue()}</span>
            </div>
          );
        },
      },
      {
          header: "Quantity",
          accessorKey: "product_edition.total_units",
          enableColumnFilter: false,
          
      },
      {
          header: "Sold",
          accessorKey: "ordered_quantity",
          enableColumnFilter: false, 
      }, 
      {
          header: "Stock on Hand",
          accessorKey: "available_quantity",
          enableColumnFilter: false,
           
      },
      {
          header: "Cost",
          accessorKey: "unit_cost",
          enableColumnFilter: false, 
      }, 
      {
          header: "Total Cost",
          accessorKey: "total_cost",
          enableColumnFilter: false,
         
      },  
     
    ],
    [handleInfo]
  );
 
  // Export Modal 

  document.title = "Inventory | SeedNations";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid> 
          <BreadCrumb title="Inventory LIST" pageTitle="CRM" />

          <Row>
            <Col xxl={12}>
              <Card id="inventoryList">
                <CardBody className="pt-0">
                  <div>
                    {/* Always show TableContainer for search functionality */}
                    <TableContainer
                      columns={columns}
                      data={(inventoryList || [])}
                      total={total}
                      currentPage={currentPage}
                      pageSize={pageSize}
                      onChange={handlePageChange}
                      isGlobalFilter={true}
                      customPageSize={10}
                      className="custom-header-css"
                      divClass="table-responsive table-card mb-2"
                      tableClass="align-middle table-nowrap"
                      theadClass="table-light"
                      isUserListFilter={true}
                      SearchPlaceholder='Search for inventory...'
                    />
                    
                    {/* Show empty state message when no results */}
                    {(!inventoryList || inventoryList.length === 0) && !loading && (
                      <div className="text-center py-5">
                        {!searchTerm && (
                          <div className="avatar-md mx-auto mb-4">
                            <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-4">
                              <i className="ri-package-line"></i>
                            </div>
                          </div>
                        )}
                        {!searchTerm && <h5>No items available</h5>}
                        <p className="text-muted">
                          {searchTerm ? 
                            `No inventory items found matching "${searchTerm}". Try adjusting your search terms or browse all items.` : 
                            'There are no inventory items in the system at the moment. Please check back later or contact an administrator.'
                          }
                        </p>
                        {searchTerm && (
                          <div className="d-flex gap-2 justify-content-center">
                            <button 
                              className="btn btn-outline-primary"
                              onClick={() => {
                                // Clear search and reload all items
                                clearSearch();
                                loadInventoryList(1, pageSize);
                              }}
                            >
                              <i className="ri-refresh-line me-1"></i>
                              Show All Items
                            </button>
                            <button 
                              className="btn btn-outline-secondary"
                              onClick={() => {
                                // Clear search but keep current page
                                clearSearch();
                                loadInventoryList(currentPage, pageSize);
                              }}
                            >
                              <i className="ri-close-line me-1"></i>
                              Clear Search
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                    
                    {/* Show loading state */}
                    {loading && (
                      <div className="text-center py-5">
                        <div className="spinner-border text-primary mb-3" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <h5>Loading inventory...</h5>
                        <p className="text-muted">
                          {searchTerm ? `Searching for "${searchTerm}"...` : 'Fetching inventory items...'}
                        </p>
                      </div>
                    )}
                  </div>
                  <Modal id="showModal" isOpen={modal} toggle={() => {
                    toggle_modal();
                }} centered size="lg">
                    <ModalHeader className="bg-info-subtle p-3" toggle={() => {
                    toggle_modal();
                }} >
                     Information
                    </ModalHeader>
                    <ModalBody>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Product Name</label>
                            <div className="form-control"> {inventory?.product.name} </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Quantity</label>
                            <div className="form-control"> {inventory?.product_edition.total_units} </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Sold</label>
                            <div className="form-control"> {inventory?.ordered_quantity} </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Stock on Hand</label>
                            <div className="form-control"> {inventory?.available_quantity} </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Cost</label>
                            <div className="form-control"> {inventory?.cost} </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Total Cost</label>
                            <div className="form-control"> {inventory?.total_cost} </div>
                          </div>
                        </div>
                      </div>
                    </ModalBody> 
                  </Modal>
                </CardBody>
              </Card>
            </Col> 
          </Row> 
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InventoryList;
